import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { primary_dark15, primary_light } from '../../../shared/lib/colors';
import {
  loadFideltyCard,
  loadFideltyPoints,
  loadActiveCoupons,
  activateFidelityCoupon,
} from '../../../../redux/modules/fideltyCard';
import './CartaFedelta.scss';
import Button from '../../../shared/Button/Button';
import { FaCheckCircle } from 'react-icons/fa';
import Link from '../../../shared/Link/Link';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

class CartaFedelta extends Component {
  componentWillMount() {
    this.props.loadFideltyCard();
    this.props.loadFideltyPoints();
    this.props.loadActiveCoupons();
  }

  handleActivateCoupon(id) {
    this.props.activateFidelityCoupon(id);
  }

  renderCard(points) {
    return (
      <>
        <div className="col-xs-12 col-md-6">
          <div className="Card-text">
            Ciao <b>{this.props.firstname}</b> siamo molto felici di <br />
            annunciare che il nostro store offre ora la Fidelity Card! <br />
            Questa card ti permette di accumulare punti <br />
            ogni volta che fai acquisti e spenderli per acquistare coupon da
            utilizzare sui tuoi prossimi acquisti
          </div>
        </div>
        <div className="col-xs-12 col-md-6">
          <div
            style={{
              backgroundColor: primary_light(this.props.primaryColor),
              border: `1px solid ${this.props.primaryColor}`,
              minHeight: 100,
              borderRadius: 8,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 24,
            }}
          >
            <b>{points} punti</b>
          </div>
        </div>
      </>
    );
  }

  renderActiveCoupons(active) {
    return active.map(coupon => {
      return (
        <Coupon
          coupon={coupon}
          products={this.props.coupons}
          couponName={coupon.name}
          primaryColor={this.props.primaryColor}
          secondaryColor={this.props.secondaryColor}
        />
      );
    });
  }

  renderCouponValue(coupon) {
    return !!coupon.discountFixed ? (
      <div>
        Sconto di{' '}
        <span style={{ fontWeight: 'bold' }}>{coupon.discountFixed}€</span>
        {/* {!coupon.brand && !coupon.category && !coupon.product && (
          <div>Su tutto</div>
        )} */}
        {coupon.brand && (
          <div>
            Su{' '}
            <b>
              {coupon.brand.charAt(0) + coupon.brand.slice(1).toLowerCase()}
            </b>
          </div>
        )}
        {coupon.category && <div>Su {coupon.category}</div>}
        {coupon.product && (
          <div>
            Su{' '}
            <b>
              {coupon.product.charAt(0) + coupon.product.slice(1).toLowerCase()}
            </b>
          </div>
        )}
      </div>
    ) : (
      <div>
        Sconto del{' '}
        <span style={{ fontWeight: 'bold' }}>{coupon.discountPercent}%</span>
        {/* {!coupon.brand && !coupon.category && !coupon.product && (
          <div>Su tutto</div>
        )} */}
        {coupon.brand && (
          <div>
            Su{' '}
            <b>
              {coupon.brand.charAt(0) + coupon.brand.slice(1).toLowerCase()}
            </b>
          </div>
        )}
        {coupon.category && <div>Su {coupon.category}</div>}
        {coupon.product && (
          <div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '2rem',
                maxWidth: '15rem',
                alignItems: 'center',
              }}
            >
              <ImageDispatcher
                src={coupon.productImage}
                style={{
                  width: '40%',
                  height: '40%',
                  maxHeight: 100,
                }}
              />

              <div
                style={{
                  minWidth: '10rem',
                  fontSize: '13px',
                  marginLeft: '1rem',
                }}
              >
                <Link
                  to={`/${coupon.type}/${coupon.subcategorySeoName}/${coupon.categorySeoName}/${coupon.productSeo}`}
                >
                  <b>
                    {coupon.product.charAt(0) +
                      coupon.product.slice(1).toLowerCase()}
                  </b>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderCoupon(coupons) {
    return coupons.map(coupon => {
      const pointsCheck = this.props.userPoints < coupon.pointNeeded;
      return (
        <div
          style={{
            display: 'flex',
            background: 'white',
            padding: 16,
            borderRadius: 8,
            justifyContent: 'space-between',
          }}
        >
          <div style={{ fontSize: 16 }}>
            <div>{coupon.name}</div>
            {this.renderCouponValue(coupon)}
          </div>
          <div style={{ fontSize: 14 }}>
            <div>Costo: {coupon.pointNeeded} punti</div>
            <Button
              className="btn btn-outline btn-thick"
              style={{
                height: '1rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              disabled={pointsCheck}
              onClick={() => this.handleActivateCoupon(coupon.id)}
            >
              Attiva
            </Button>
          </div>
        </div>
      );
    });
  }

  render() {
    return (
      <div className="container">
        <h3 className="Coupon-title">Coupons</h3>
        <div className="row" style={{}}>
          {this.renderCard(this.props.userPoints)}
        </div>
        <div className="row" style={{ marginTop: '2rem' }}>
          <div className="col-xs-12 col-md-6">
            <h3>Coupon Disponibili</h3>
            {this.props.coupons && this.props.coupons.length > 0 ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {this.renderCoupon(this.props.coupons)}
              </div>
            ) : (
              <span>Nessun coupon disponibile</span>
            )}
          </div>
          <div className="col-xs-12 col-md-6">
            <h3>Coupon Attivi</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {this.renderActiveCoupons(this.props.activeCoupons)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    firstname: state.user.data.billing.firstname,
    coupons: state.card.data,
    userPoints: state.card.points,
    activeCoupons: state.card.coupons,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    secondaryColor: state.store.data.loghiTemplate.secondaryColor,
    couponProduct: state.card.data.product,
  };
};

export default connect(mapStateToProps, {
  loadFideltyCard,
  loadFideltyPoints,
  loadActiveCoupons,
  activateFidelityCoupon,
})(CartaFedelta);

const Coupon = ({
  coupon,
  products,
  couponName,
  primaryColor,
  secondaryColor,
}) => {
  const [isApplied, setIsApplied] = useState(false);

  function renderCouponValue(coupon) {
    return !!coupon.discountFixed ? (
      <div>
        Sconto di{' '}
        <span style={{ fontWeight: 'bold' }}>{coupon.discountFixed}€</span>
      </div>
    ) : (
      <div>
        Sconto del{' '}
        <span style={{ fontWeight: 'bold' }}>{coupon.discountPercent}%</span>
        {products.map(item => {
          return (
            (item.category != null && item.name === couponName && (
              <div>
                Su{' '}
                {item.category.charAt(0) + item.category.slice(1).toLowerCase()}
              </div>
            )) ||
            (item.brand != null && item.name === couponName && (
              <div>
                Su {item.brand.charAt(0) + item.brand.slice(1).toLowerCase()}
              </div>
            )) ||
            (item.product != null && item.name === couponName && (
              <div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '.5rem',
                    maxWidth: '15rem',
                    alignItems: 'center',
                  }}
                >
                  <ImageDispatcher
                    src={item.productImage}
                    style={{
                      width: '40%',
                      height: '40%',
                      maxHeight: 100,
                    }}
                  />

                  <div
                    style={{
                      minWidth: '10rem',
                      fontSize: '13px',
                      marginLeft: '1rem',
                    }}
                  >
                    <Link
                      to={`/${item.type}/${item.subcategorySeoName}/${item.categorySeoName}/${item.productSeo}`}
                    >
                      <b>
                        {item.product.charAt(0) +
                          item.product.slice(1).toLowerCase()}
                      </b>
                    </Link>
                  </div>
                </div>
              </div>
            ))
          );
        })}
      </div>
    );
  }

  const handleApplyCoupon = () => {
    localStorage.setItem('coupon', coupon.code);
    setIsApplied(true);
  };

  const isExpired = moment() > moment(coupon.expiresAt);
  const isUsable = coupon.maxUses > coupon.numUses;

  const ERROR_COLOR = '#e60c55';
  const OK_COLOR = '#22ca4b';

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        borderRadius: 8,
        padding: 16,
        backgroundColor: !isUsable
          ? primary_light(OK_COLOR)
          : isExpired || !coupon.isEnabled
          ? primary_light(ERROR_COLOR)
          : 'white',
      }}
    >
      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'column',
        }}
      >
        <div>
          <b>{coupon.code}</b>
        </div>
        <div style={{ fontSize: 14 }}>{renderCouponValue(coupon)}</div>
      </div>
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
        }}
      >
        {!isUsable ? (
          <div style={{ fontSize: 14, color: OK_COLOR }}>Usato</div>
        ) : isExpired ? (
          <div style={{ fontSize: 14, color: ERROR_COLOR }}>Scaduto</div>
        ) : !coupon.isEnabled ? (
          <div style={{ fontSize: 14, color: ERROR_COLOR }}>Disabilitato</div>
        ) : (
          <>
            <div style={{ fontSize: 14 }}>
              Scadenza: {moment(coupon.expiresAt).format('DD/MM/YYYY')}
            </div>
            {isApplied ? (
              <div
                style={{
                  color: 'green',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 4,
                  fontSize: 14,
                }}
              >
                <FaCheckCircle size={16} color="green" />
                APPLICATO
              </div>
            ) : (
              <Button
                disabled={isExpired}
                className="btn btn-outline btn-thick"
                onClick={handleApplyCoupon}
                style={{
                  height: '1rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                APPLICA
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
};
